import { Component } from "react";
import { NavLink } from "react-router-dom";
import profileImage from '../adminassets/img/profileIcon.jpg';
import logoImage from '../adminassets/img/logo_temple.png';
import { ToastContainer } from "react-toastify";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Dropdown } from "react-bootstrap";
import AdminService from "../services/AdminService";
import history from "../history";

interface Props {
}

interface State {
  toggleMenuBar: boolean,
  activeSvc: string,
  menu1: boolean,
  menu2: boolean,
  menu3: boolean,
  menu4: boolean,
}

export class AdminLayout extends Component<Props, State> {

  constructor(props: any) {
    super(props);
    this.state = {
      toggleMenuBar: false,
      activeSvc: "",
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
    }
  }

  componentDidMount() {
  //  var sheet = document.getElementById("clientStyle");
  //   sheet.parentNode.removeChild(sheet)
  
  var user = JSON.parse(localStorage.getItem("user"));
  if(user)
  {
    //alert(window.location.origin);
      if(!user.isAdmin)
      {
        history.push("/");              
      }
      
  }
  else{
      history.push(`/SignIn/`);
  }

    require('../adminassets/vendor/fontawesome-free/css/all.min.css');
    // require('../adminassets/vendor/bootstrap/css/bootstrap.min.css');
    // require('../adminassets/css/admin-Styles.css');
    require('../assets/styles/style.css');
  }

  toggleSideMenuBar = () => {
    if (this.state.toggleMenuBar) {
      this.setState({ toggleMenuBar: false });
    }
    else {
      this.setState({ toggleMenuBar: true });
    }
  }

  UserLogOut = async (e) => 
	{   	
		localStorage.removeItem("user");
		AdminService.UserLogOut();
    history.push(`/SignIn/`);
	}

  // activeSubMenu = (menuName, e) => {
  //   if (menuName == "svcEvents" && e.target.innerText == "Services & Events") {
  //     if (this.state.activeSvc) 
  //     {
  //       this.setState({ activeSvc: "" });
  //     }
  //     else {
  //       this.setState({ activeSvc: "show" });
  //     }
  //   }
  // }

  activeMenu = (menu) => 
  {  
    this.setState({menu1:false,menu2:false,menu3:false,menu4:false});
    if(menu == "menu1")
    {
      this.setState({menu1:true,activeSvc: this.state.activeSvc =="show" ? "false": "show"});
    }
    if(menu == "menu2"){
      this.setState({menu2:true,activeSvc: "false"});
    }
    if(menu == "menu3"){
      this.setState({menu3:true,activeSvc: "false"});
    }
    if(menu == "menu4"){
      this.setState({menu4:true,activeSvc: "false"});
    }
  }

  render() {
    const { toggleMenuBar, activeSvc, menu1,menu2,menu3,menu4} = this.state;
    return (
      <div>
        <div>
          <ToastContainer />
          <div id="wrapper" className={(toggleMenuBar ? " sidebar-toggled" : "")}> 
            <ul className={"navbar-nav sidebar sidebar-light accordion" + (toggleMenuBar ? " toggled" : "")} id="accordionSidebar">
              <a className="sidebar-brand d-flex align-items-center justify-content-center" href="index.html">
                <div className="sidebar-brand-icon">
                  <img src={logoImage} />
                </div>
                <div className="sidebar-brand-text mx-3">Temple Admin</div>
              </a>
              <li className="nav-item" data-toggle="collapse" data-target="#collapseBootstrap" aria-expanded="false" aria-controls="collapseBootstrap">
                <a className={"nav-link "} href="" onClick={(e) => e.preventDefault()}>
                  <i className="fas fa-fw fa-cog" />
                  { this.state.menu1 ?
                  <span onClick={()=> this.activeMenu("menu1")} style={{ color: "#fd9e39" }}>{"Services & Events"}</span>:<span onClick={()=> this.activeMenu("menu1")}>{"Services & Events"}</span>}
                  {this.state.activeSvc == "show" ? <ExpandMore className="icon-collapse" /> : <ArrowForwardIosIcon className="sd icons-expand" />}
                </a>
                <div id="collapseBootstrap" className={activeSvc ? "collapse " + (activeSvc) : "collapse "}>
                  <div className="bg-white py-2 collapse-inner rounded">
                    <NavLink className="collapse-item" to={"/ServiceManagement"} activeStyle={{ color: "#fd9e39" }}>{"Services"}</NavLink >
                    <NavLink className="collapse-item" to={"/EventsDetails"} activeStyle={{ color: "#fd9e39" }}>{"Events"}</NavLink >
                    <NavLink className="collapse-item" to={"/ImageGalleryAdmin"} activeStyle={{ color: "#fd9e39" }}>{"Image Gallery"}</NavLink >
                    <NavLink className="collapse-item" to={"/FilesAdmin"} activeStyle={{ color: "#fd9e39" }}>{"Files"}</NavLink >
                    <NavLink className="collapse-item" to={"/PriestDetails"} activeStyle={{ color: "#fd9e39" }}>{"Priest Details"}</NavLink >
                    <NavLink className="collapse-item" to={"/AdminHinduGods"} activeStyle={{ color: "#fd9e39" }}>{"Hindu Gods"}</NavLink >
                    <NavLink className="collapse-item" to={"/AdminBoardMembers"} activeStyle={{ color: "#fd9e39" }}>{"Board Members"}</NavLink >
                    <NavLink className="collapse-item" to={"/UpdateNews"} activeStyle={{ color: "#fd9e39" }}>{"Latest News"}</NavLink >
                    <NavLink className="collapse-item" to={"/UpdateSlider"} activeStyle={{ color: "#fd9e39" }}>{"Slider"}</NavLink >
                    <NavLink className="collapse-item" to={"/MultiServiceApproval"} activeStyle={{ color: "#fd9e39" }}>{"Service Approval"}</NavLink >
                    <NavLink className="collapse-item" to={"/AdminAnnualSubscription"} activeStyle={{ color: "#fd9e39" }}>{"Annual Subscription"}</NavLink >
                  </div>
                </div>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={"/PriestShedule"} activeStyle={{ color: "#fd9e39" }} onClick={()=> this.activeMenu("menu2")}>
                  <i className="fas fa-fw fa-calendar-alt"></i>
                  <span className={menu2 ? "nav-link yourclassName mar-lft" : null}> {"Priest Shedule"}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={"/UpdateMissionAndVision"} activeStyle={{ color: "#fd9e39" }} onClick={()=> this.activeMenu("menu3")}>
                  <i className="fas fa-fw fa-bullseye"></i>
                  <span className={menu3 ? "nav-link yourclassName mar-lft" : null}> {"Mission & Vision"}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={"/TempleTimeManagement"} activeStyle={{ color: "#fd9e39" }} onClick={()=> this.activeMenu("menu4")}>
                  <i className="fas fa-fw fa-clock"></i>
                  <span className={menu4 ? "nav-link yourclassName mar-lft" : null}>Temple Timings</span>
                </NavLink>
              </li>
            </ul>
            {/* Sidebar */}
            {/* TopNavBar */}
            <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                {/* TopBar */}
                <nav className="navbar navbar-expand navbar-light bg-navbar topbar mb-4 static-top">
                  <button className="btn btn-link rounded-circle mr-3" onClick={() => this.toggleSideMenuBar()}>
                    <i className="fa fa-bars" />
                  </button>
                  <ul className="navbar-nav ml-auto">
                    <div className="topbar-divider d-none d-sm-block" />
                    {/* <li className="nav-item dropdown no-arrow">
                      <a className="nav-link dropdown-toggle" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img className="img-profile rounded-circle" src={profileImage} style={{ maxWidth: 60 }} />
                        <span className="ml-2 d-none d-lg-inline text-white small">{"Admin"}</span>
                      </a>
                      <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                        <a className="dropdown-item" href="#">
                          <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400" />
                          Profile
                        </a>
                        <div className="dropdown-divider" />
                        <a className="dropdown-item" href="#" data-toggle="modal" data-target="#logoutModal">
                          <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
                          Logout
                        </a>
                      </div>
                    </li> */}
               
                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic" className="header-dropmenu">
                        <img className="img-profile rounded-circle" src={profileImage} style={{ maxWidth: 30 }} />
                        <span style={{ marginLeft: "10px" }}>Admin</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropmenu-hd">
                        <Dropdown.Item className="item-color">  <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>Profile</Dropdown.Item>
                        <Dropdown.Item className="item-color" onClick={(e) => this.UserLogOut(e)}> <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>Logout</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <span style={{ marginRight: "10px" }}></span>
                  </ul>
                </nav>
                {/* Topbar */}
                {/* Container Fluid*/}
                <div className="container-fluid" id="container-wrapper">
                  {this.props.children}
                </div>
                {/*-Container Fluid*/}
              </div>
            </div>
          </div>
        </div>


      </div>
    )
  }
}